<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import formEdit from './add'

export default {
  components: {
    formEdit
  },
  data() {
    return {
      validationErrors: [],
      title: "Thêm mới loại tôm",
      mode: 'add',
      models: {},
      componentKey: 0,
      page_transaction: null,
      id: null
    }
  },
  async mounted () {
    this.mode = this.$route.name === 'editShrimp' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Chỉnh sửa loại tôm' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_USER);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-shrimp' });
    },
    async saveData(params) {
      if (!params || Object.entries(params).length === 0) {
        console.error("Invalid parameters passed to saveData:", params);
        return;
      }

      const code = "shrimp";
      // Get the id from kind_type table where kind_type.code = "shrimp"
      var kindTypeQuery = DataServices.getList("kind_type");
      var kindTypeRes = await this.$apollo.mutate({
        mutation: kindTypeQuery,
        variables: {
          where_key: { code: { _eq: code } }
        }
      });
      var kindTypeId = kindTypeRes.data.kind_type[0].id;

      const objects = {
        name: params.name,
        code: params.code,
        weight: params.weight,
        growth: params.growth,
        number_days_growth: params.number_days_growth,
        active: params.active,
        type_id: kindTypeId
      };

      try {
        this.$commonFuction.is_loading(true);

        let response;
        if (this.mode === "add") {
          response = await this.$apollo.mutate({
            mutation: DataServices.insertData("kind"),
            variables: { objects },
          });
        } else {
          const variables = {
            data_update: objects,
            where_key: { id: { _eq: this.models.id } },
          };
          response = await this.$apollo.mutate({
            mutation: DataServices.updateData("kind"),
            variables,
          });
        }

        const affectedRows = response.data[Object.keys(response.data)].affected_rows;
        if (affectedRows > 0) {
          await this.redirectEdit();
        } else {
          this.showErrorToast();
        }
      } catch (error) {
        console.error("Error during saveData mutation:", error);
        this.showErrorToast();
      } finally {
        this.$commonFuction.is_loading(false);
      }
    },

    showErrorToast() {
      this.$toast.add({
        severity: "error",
        summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
        detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
        life: 3000,
      });
    },

    async redirectEdit() {
      this.$commonFuction.is_loading(false);

      const routerBack = { path: '/admin/list-shrimp' };

      if (this.mode === "add") {
        this.$router.push(routerBack);
      } else {
        if (!this.$commonFuction.isEmpty(this.page_transaction)) {
          routerBack.query = { page_transaction: this.page_transaction.toString() };
        }
        this.$router.push(routerBack);
      }

      this.$toast.add({
        severity: "success",
        summary: "Success",
        detail: "Save data successfully",
        life: 3000,
      });
    },

    async getData(id) {
      try {
        const { data } = await this.$apollo.query({
          query: DataServices.getList("kind"),
          variables: { where_key: { id: { _eq: id } } },
          fetchPolicy: "network-only",
        });

        const models = data[Object.keys(data)];
        if (models.length > 0) {
          this.models = { ...models[0] }; // Spread to avoid reactivity issues
          this.componentKey++;
        }
      } catch (error) {
        console.error("Error fetching data for ID:", id, error);
      }
    },
  }
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;}
      }
      .box-images{ margin-top: 10px; position: relative;
        .item-img{height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative; border: 0.5px solid #ccc;
          &.p-col-5{width: 18%;;}
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain;}
          .button-clear{width: 18px; height: 18px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 5px; padding: 0;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>
<style>
.list-group-v {
  /* display: -webkit-box;
   display: -ms-flexbox;*/
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  /*-ms-flex-direction: column;*/
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.list-group-item-v:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}
.list-group-item-v {
  position: relative;
  display: block;
  padding: .75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125) ;
  height: 50px;
}
.box-check-box{
  position: relative;
}
.box-check-box label{
  position: absolute;
  left: 0px;
  top: 2px;
}
.box-check-box .check-box-day{
  position: absolute;
  right: 0px;
  top: 2px;
}
</style>